import { Injectable } from '@angular/core';
import {
	HttpRequest,
	HttpHandler,
	HttpInterceptor,
	HTTP_INTERCEPTORS,
	HttpHeaders
} from '@angular/common/http';
import { FacadeService } from '../services/facade.service';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {
	constructor(private facade: FacadeService) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
		let authReq = req;
		const token = this.facade.dataStorageService.getJwtToken();
		if (token !== null) {
			if (!req.url.includes('api-adresse')) {
				authReq = this.addTokenAndTimestampHeaders(req, token);
			}
		}
		return next.handle(authReq);
	}

	private addTokenAndTimestampHeaders(request: HttpRequest<any>, token: string) {
		let headers = new HttpHeaders({
			'Authorization': 'Bearer ' + token,
			'Timestamp': new Date().getTime() + ''
		});
		request = request.clone({
			headers: headers
		});
		// ajouter afin d'obtenir une HttpResponse complète avec Angular (cf : http-error-interceptor, l'obtention de header custom)
		request.params.append('observe', 'response');
		return request;
	}
}

export const authInterceptorProviders = [
	{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
];
